import { createRouter, createWebHistory } from 'vue-router'
import { validAddress } from '../state'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/scorecard',
        name: 'scorecard',
        component: () => import('../views/Scorecard.vue'),
        beforeEnter(to, from, next) {
            if (validAddress.data === undefined) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import('../views/Signup.vue'),
        beforeEnter(to, from, next) {
            if (validAddress.data === undefined) {
                next('/')
            } else {
                next()
            }
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router